module.exports = __webpack_public_path__ + "static/media/albaraka_api_v1.990fc951.png";